import { LANG } from '@/common/constants/language';

export const getSchoolsNetworkUrl = (language: string) => {
  let suffix = '';
  switch (language) {
    case LANG.EN:
      suffix = '/en';
      break;
    case LANG.PT:
      suffix = '/pt';
      break;
  }

  return `${process.env.EXPO_PUBLIC_NETWORKS_URL}${suffix}/childcare/pt?origin=wallet`;
};
